module.exports = __webpack_public_path__ + "img/outline_blue_eye.2e339e1b.svg";